import { BRAND } from "@/lib/brand";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";

const QUICK = [
  { href: "#solucoes", label: "Soluções Corporativas e Industriais" },
  { href: "#nacionalizacao", label: "Nacionalização de Componentes" },
  { href: "#quem-somos", label: "Quem Somos" },
  { href: "#diferenciais", label: "Diferenciais" },
  { href: "#mercados", label: "Mercados" },
  { href: "#categorias", label: "Categorias" },
  { href: "#faq", label: "FAQ" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-navy text-white overflow-hidden grain"
    >
      <div
        className="absolute -top-40 right-0 w-[500px] h-[500px] rounded-full blur-3xl opacity-20"
        style={{ background: "radial-gradient(closest-side, rgba(184,134,58,0.7), transparent)" }}
        aria-hidden
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-24">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <a href="#home" className="flex items-center gap-3 mb-6" data-testid="footer-logo">
              <img
                src={BRAND.logoUrl}
                alt="Imporparts"
                className="h-28 w-28 rounded-md bg-white object-contain"
                loading="lazy"
              />
              <div>
                <div className="font-display font-bold text-xl">Imporparts</div>
                <div className="text-[10px] tracking-[0.22em] uppercase font-semibold text-gold">
                  Soluções Corporativas
                </div>
              </div>
            </a>
            <p className="text-white/70 max-w-md leading-relaxed">
              Mantemos operações em movimento. Tudo o que sua indústria precisa
              para nunca parar — do rolamento à peça descontinuada.
            </p>
            <a
              href={BRAND.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-btn"
              className="btn-primary mt-8 text-sm"
            >
              <MessageCircle className="w-4 h-4" /> Solicitar Cotação
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="tracking-eyebrow text-gold mb-5">Navegue</div>
            <ul className="space-y-3">
              {QUICK.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-white/75 hover:text-gold transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="tracking-eyebrow text-gold mb-5">Contato</div>
            <ul className="space-y-4 text-white/80">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 shrink-0 text-gold" />
                <span>
                  {BRAND.address.street}, {BRAND.address.district}
                  <br />
                  {BRAND.address.city} — {BRAND.address.state}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 shrink-0 text-gold" />
                <a href="tel:+551126704419" className="hover:text-gold transition-colors">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle className="w-4 h-4 shrink-0 text-gold" />
                <a
                  href={BRAND.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold transition-colors"
                >
                  {BRAND.whatsapp}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 shrink-0 text-gold" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-gold transition-colors">
                  {BRAND.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-white/50 text-sm">
          <div>
            © {new Date().getFullYear()} Imporparts — Soluções Corporativas e Industriais. Todos os direitos reservados.
          </div>
          <div className="flex items-center gap-6">
            <a
              href="#quem-somos"
              className="hover:text-gold transition-colors"
              data-testid="footer-privacy"
            >
              Política de Privacidade
            </a>
            <span className="tracking-eyebrow text-white/40">
              Mantemos operações em movimento
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
